<template>
  <div>
    <homeNav @switchTab="switchTab" />
    <imgView />
    <scienceTabs ref="child" />
    <backtop />
    <homeFooter />
  </div>
</template>

<script>
  import homeNav from '../../components/homeNav';
  import imgView from '../../components/imgView';
  import scienceTabs from './components/scienceTabs'
  import homeFooter from '../../components/homeFooter';
  import backtop from '../../components/backtop';

  export default {
    name: "scienceResearch",
    data() {
      return {
        tabIndex: 0 //默认tabs
      }
    },
    created() {
      this.tabIndex = this.$route.query.tabIndex;

    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.child.switchTab(this.tabIndex);
      })
    },
    methods: {
      switchTab(index) {
        this.$nextTick(() => {
          this.$refs.child.switchTab(index);
        })
      }
    },
    components: {
      homeNav,
      imgView,
      scienceTabs,
      homeFooter,
      backtop,
    },
    watch: {
      $route(to, from) {
        //首页传入的tabIndex 和所在页面tabIndex不相等就切换tab
        if (this.tabIndex != this.$route.query.tabIndex) {
          this.tabIndex = this.$route.query.tabIndex;
          this.$refs.child.switchTab(this.tabIndex);
        }
      }
    },
  }
</script>

<style scoped>
</style>